import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { FaCheck, FaWhatsapp, FaEnvelope, FaCalendarAlt } from 'react-icons/fa';
import axios from 'axios';

const API_URL = 'https://aamirsaba.com/api';

const Training = () => {
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showEnrollPopup, setShowEnrollPopup] = useState(false);
  const [selectedCourse, setSelectedCourse] = useState('');

  useEffect(() => {
    axios.get(`${API_URL}/training`)
      .then(response => {
        console.log('Training courses loaded:', response.data);
        setCourses(response.data);
        setLoading(false);
      })
      .catch(error => {
        console.error('Error loading training courses:', error);
        setLoading(false);
      });
  }, []);

  const handleEnrollClick = (courseTitle) => {
    setSelectedCourse(courseTitle);
    setShowEnrollPopup(true);
  };

  const closePopup = () => {
    setShowEnrollPopup(false);
    setSelectedCourse('');
  };

  if (loading) {
    return (
      <section className="pt-32 pb-20 bg-navy min-h-screen">
        <div className="container mx-auto px-6 text-center">
          <div className="text-cyan text-xl">Loading...</div>
        </div>
      </section>
    );
  }

  return (
    <section className="pt-32 pb-20 bg-navy min-h-screen">
      <div className="container mx-auto px-6">
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="text-center mb-16">
          <h1 className="text-4xl md:text-6xl font-bold">Professional <span className="text-cyan">Training</span></h1>
          <p className="text-gray-400 mt-4 max-w-2xl mx-auto">Upskill your team with industry-leading certification programs</p>
        </motion.div>

        {courses.length === 0 ? (
          <div className="text-center py-12">
            <p className="text-gray-400 text-lg">No training courses available at the moment.</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {courses.map((course, index) => {
              let features = course.features;
              if (typeof features === 'string') {
                try { features = JSON.parse(features); } catch(e) { features = []; }
              }
              if (!Array.isArray(features)) features = [];

              return (
                <motion.div 
                  key={course.id || index} 
                  initial={{ opacity: 0, y: 20 }} 
                  animate={{ opacity: 1, y: 0 }} 
                  transition={{ delay: index * 0.1 }} 
                  className="bg-darkNavy rounded-xl p-8 border border-gray-800 hover:border-cyan transition group"
                >
                  <h3 className="text-2xl font-bold text-cyan">{course.title}</h3>
                  <div className="mt-4 space-y-2 text-sm text-gray-300">
                    <p><span className="font-semibold">Duration:</span> {course.duration}</p>
                    <p><span className="font-semibold">Level:</span> {course.level}</p>
                    <p><span className="font-semibold">Price:</span> <span className="text-cyan font-bold">{course.price}</span></p>
                  </div>
                  <ul className="mt-4 space-y-2">
                    {features.map((feature, i) => (
                      <li key={i} className="text-sm text-gray-400 flex items-center gap-2">
                        <FaCheck className="text-cyan text-xs" /> {feature}
                      </li>
                    ))}
                  </ul>
                  <button 
                    onClick={() => handleEnrollClick(course.title)}
                    className="mt-6 w-full px-4 py-3 bg-cyan text-navy rounded-full font-semibold hover:bg-cyan/80 transition group-hover:shadow-lg group-hover:shadow-cyan/25"
                  >
                    Enroll Now →
                  </button>
                </motion.div>
              );
            })}
          </div>
        )}
      </div>
    </section>
  );
};

export default Training;
